module.exports = __webpack_public_path__ + "img/largephoto-shape.4d77a204.svg";